import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'removeTags' })
export class RmTagsPipe implements PipeTransform {
  transform(data: string, activate: boolean | any = true) {
    return activate ? data.replace(/<\/?[^>]+(>|$)/g, '') : data;
  }
}
